import { useEffect, useState } from 'react';
import { fetchCourseUsers, fetchDropdownsInformation, enrollUsers } from 'Api/editCourseMembers';

const useFetch = (courseId, setIsLoading) => {
  const [users, setUsers] = useState([]);
  const [courseUsers, setCourseUsers] = useState([]);
  const [department, setDepartment] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [jobTitle, setJobTitle] = useState(null);
  const [jobTitles, setJobTitles] = useState([]);
  const [terminal, setTerminal] = useState(null);
  const [terminals, setTerminals] = useState([]);
  const [fullName, setFullName] = useState(null);

  useEffect(() => {
    const newDepartment = department === '' ? null : department;
    const newJobTitle = jobTitle === '' ? null : jobTitle;
    const newTerminal = terminal === '' ? null : terminal;
    let isMounted = true;

    if (isMounted) {
      fetchCourseUsers({
        courseId,
        department: newDepartment,
        jobTitle: newJobTitle,
        terminal: newTerminal,
        fullName,
      }).then(data => {
        setCourseUsers(data.courseUsers);
        setUsers(data.users);
        setIsLoading(false);
      });
    }

    return () => {
      isMounted = false;
      setCourseUsers([]);
      setUsers([]);
      setIsLoading(true);
    };
  }, [courseId, department, jobTitle, terminal, fullName]);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchDropdownsInformation().then(data => {
        setDepartments(data.departments);
        setJobTitles(data.jobTitles);
        setTerminals(data.terminals);
      });
    }

    return () => {
      isMounted = false;
      setDepartment([]);
      setJobTitles([]);
      setTerminals([]);
    };
  }, []);

  return {
    users,
    courseUsers,
    departments,
    jobTitles,
    terminals,
    setUsers,
    setCourseUsers,
    setDepartment,
    setJobTitle,
    setTerminal,
    setFullName,
    enrollUsers,
  };
};

export default useFetch;
